var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"diagnostics\">\n<div class=\"row\">\n<div class=\"col-md-12\">\n<eshq-cluster-navigation></eshq-cluster-navigation>\n</div>\n</div>\n<div class=\"row\" ng-repeat=\"group in diagnosticsCtrl.data\">\n<div class=\"col-md-4\" ng-repeat=\"item in group\">\n<eshq-node-diagnostics-wrapper node-info=\"item\"></eshq-node-diagnostics-wrapper>\n</div>\n</div>\n</div>";
var id1="containers/diagnostics/diagnostics.view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/containers/diagnostics/diagnostics.view.html
// module id = 809
// module chunks = 0